import ReactDOM from 'react-dom/client'

import App from './App'
import 'normalize.css'

ReactDOM.createRoot(document.getElementById('root')).render(<App/>)
